import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { AppBar, Box, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';
import axios from 'utils/axios';
// project imports
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';
import Header from './Header';
import Sidebar from './Sidebar';
import navigation from 'menu-items';
import { drawerWidth } from 'store/constant';
import {
    SET_MENU,
    SET_ACTIVE_PAGE,
    SET_USER_DATA,
    SET_COMPANY_DATA,
    SET_USER_PROFILE,
    SET_COMPANY_PROFILE,
    SET_MODAL_STATUS,
    SET_MODAL_TYPE,
    CLEAR_DATA,
    SET_COMPANY_PROFILE_IS_UPDATING
} from 'store/actions';
// assets
import { IconChevronRight } from '@tabler/icons';
import Toast from 'Components/Toast';
import { loggedInUserQuery, getImage } from 'utils/apolloQueries';
import {
    setIsLoggedIn,
    SET_AUTHENTICATED_USER_DATA,
    SET_COMPANY_CREATOR_FLAG,
    SET_COMPANY_LIST,
    SET_COMPANY_VALIDATED,
    SET_PERMISSIONS,
    SET_SUBSCRIBED
    // SHOW_NOT_SUBSCRIBED_NON_CREATOR
} from 'store/Authentication/actions';
import ModalBox from 'views/pages/dashboard/ModalBox';
// import DashboardSidebar from './DashboardSidebar';
// import { GET_USER_DETAILS_WITH_COMPANY } from 'schemas/query';
// import { useLazyQuery } from '@apollo/client';
// import NotValidatedModal from 'views/pages/dashboard/ModalBox/NotValidated';
// import NotSubscribedModal from 'views/pages/dashboard/ModalBox/NotSubscribed';
// import NotSubscribedForNonCreatorModal from 'views/pages/dashboard/ModalBox/NotSubscribedForNonCreator';
// styles

import LAYOUT_CONST from 'store/constant';
import { checkHttps } from 'helper/string.helper';
import UploadAlert from 'views/pages/dashboard/Announcements/AnnouncementModal/UploadAlert';
import IntegrateDiologQuestions from 'views/pages/dashboard/Dashboard/IntegrateDiologQuestions';
import PermissionWrapper from 'Components/PermissionWrapper';
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
    ...theme.typography.mainContent,
    ...(!open && {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('lg')]: {
            marginLeft: -136,
            // width: `calc(100% - ${drawerWidth}px - 320px)`
            width: `calc(100% - ${drawerWidth}px)`
        },
        [theme.breakpoints.down('lg')]: {
            marginLeft: '20px',
            // width: `calc(100% - ${drawerWidth}px)`,
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '16px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px',
            width: '100%',
            padding: '16px',
            marginRight: '10px'
        }
    }),
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        width: `calc(100% - ${drawerWidth}px)`,
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px'
        }
    })
}));
const MainLayout = () => {
    // const params = useParams();
    const theme = useTheme();
    const [isDashboard, setIsDashboard] = useState(false);
    const navigate = useNavigate();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('lg'));
    const location = useLocation();
    const leftDrawerOpened = useSelector((state) => state.customization.opened);
    const { loading, userData, companyData, firstTimeLogin } = useSelector((state) => state.customization);
    const { uploadingMedia } = useSelector((params) => params.announcements);
    const getTotalItemsWithoutCancelledFromGivenArray = () => {
        return uploadingMedia.filter((item) => !item?.isCancelled).length;
    };
    const { plan, companyCreator } = localStorage.getItem('diologUserData') ? JSON.parse(localStorage.getItem('diologUserData')) : '';
    // const { hasSubscribed, showNotSubscribedForNonCreatorMessage, showNotSubscribedMessage, showNotValidationMessage } = useSelector(
    //     (state) => state.authentication
    // );
    // const [openNotValidatedModal, setOpenNotValidatedModal] = useState(false);
    // const [openNotNotSubscribedModal, setOpenNotSubscribedModal] = useState(false);
    // const [openNotSubscribedNonCreatorModal, setOpenNotSubscribedNonCreatorModal] = useState(false);
    // const handleCloseNotValidated = () => setOpenNotValidatedModal(false);
    // const handleOpenNotValidated = () => setOpenNotValidatedModal(true);
    // const handleCloseNotSubscribed = () => setOpenNotSubscribedModal(false);
    // const handleOpenNotSubscribed = () => setOpenNotSubscribedModal(true);
    // const handleCloseNotSubscribedNonCreator = () => setOpenNotSubscribedNonCreatorModal(false);
    // const handleOpenNotSubscribedNonCreator = () => setOpenNotSubscribedNonCreatorModal(true);
    const dispatch = useDispatch();
    const handleLeftDrawerToggle = () => {
        dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
    };
    useEffect(() => {
        dispatch({ type: SET_MENU, opened: !matchDownMd });
    }, [matchDownMd]);
    // useEffect(() => {
    //     if (showNotValidationMessage != 0) {
    //         setOpenNotValidatedModal(true);
    //         dispatch({ type: SET_MODAL_TYPE, modalType: 'not_validated' });
    //         dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
    //     } else if (showNotSubscribedMessage != 0) {
    //         setOpenNotSubscribedModal(true);
    //         dispatch({ type: SET_MODAL_TYPE, modalType: 'not_subscribed' });
    //         dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
    //     } else if (showNotSubscribedForNonCreatorMessage != 0) {
    //         setOpenNotSubscribedNonCreatorModal(true);
    //         dispatch({ type: SET_MODAL_TYPE, modalType: 'not_subscribed_non_creator' });
    //         dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
    //     }
    // }, [showNotValidationMessage, showNotSubscribedForNonCreatorMessage, showNotSubscribedMessage]);

    // useEffect(() => {
    //     getCompanyDetail();
    // }, [location.pathname]);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            return (event.returnValue = `Are you sure you want to leave this page? \n Leaving this page will discard all progress made to announcements being published.`);
        };
        const show = Boolean(getTotalItemsWithoutCancelledFromGivenArray());
        if (show) {
            window.addEventListener('beforeunload', handleBeforeUnload);
        }

        return () => {
            if (show) {
                window.removeEventListener('beforeunload', handleBeforeUnload);
            }
        };
    }, [uploadingMedia]);
    useEffect(() => {
        let pathName = location.pathname;
        if (pathName === '/dashboard/profile' || pathName === '/dashboard/company-profile') {
            dispatch({ type: SET_ACTIVE_PAGE, activePage: 'profile' });
            setIsDashboard(false);
        } else if (pathName === '/dashboard') {
            setIsDashboard(true);
        } else {
            dispatch({ type: SET_ACTIVE_PAGE, activePage: null });
            setIsDashboard(false);
        }
    }, [location.pathname]);
    useEffect(() => {
        let userDataNew = localStorage.getItem('diologUserData');
        if (userDataNew) {
            let userDataParsed = JSON.parse(userDataNew);
            let variables = {
                company: {
                    companyId: userDataParsed.companyId
                },
                // activitiesListInput: {
                //     limit: 5,
                //     page: 1
                // },
                companyId: userDataParsed.companyId
            };
            let submitData = { query: loggedInUserQuery, variables: variables };
            const token = localStorage.getItem('diologAuthToken');
            axios({
                method: 'POST',
                data: submitData,
                headers: { Authorization: `${token}` }
            })
                .then(function (response) {
                    if (response.status === 200 && response?.data?.data) {
                        const { loggedInUserDetail, getCompanyDetail, getTotalUnreadQuestions, userCompanyList } = response.data.data;
                        dispatch({ type: SET_USER_DATA, userData: loggedInUserDetail });
                        dispatch({
                            type: SET_COMPANY_VALIDATED,
                            companyValidated: getCompanyDetail.validated
                        });
                        dispatch({
                            type: SET_SUBSCRIBED,
                            hasSubscribed:
                                getCompanyDetail.subscription.status == 'active' || getCompanyDetail.subscription.status == 'trialing'
                                    ? true
                                    : false
                        });
                        dispatch({ type: SET_PERMISSIONS, permissions: getCompanyDetail.permissions });
                        //localStorage.setItem('permissions', JSON.stringify(getCompanyDetail.permissions));
                        dispatch({ type: SET_AUTHENTICATED_USER_DATA, userData: loggedInUserDetail });
                        dispatch({ type: SET_COMPANY_DATA, companyData: getCompanyDetail });
                        dispatch({ type: SET_COMPANY_LIST, companyList: userCompanyList });
                        dispatch({ type: SET_COMPANY_CREATOR_FLAG, companyCreator: getCompanyDetail.companyCreator });
                        if (firstTimeLogin == true) {
                            dispatch({ type: SET_MODAL_TYPE, modalType: 'first_time_login' });
                            dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
                        }
                    }
                })
                .catch(function (response) {
                    localStorage.removeItem('diologAuthToken');
                    localStorage.removeItem('diologRefToken');
                    localStorage.removeItem('diologUserData');
                    dispatch({ type: CLEAR_DATA });
                    dispatch({ type: setIsLoggedIn, isLoggedIn: false });
                    console.log(response, 'failed loading user data');
                });
        }
    }, [location.pathname]);
    useEffect(() => {
        const token = localStorage.getItem('diologAuthToken');
        if (userData.profileImage) {
            if (checkHttps(userData.profileImage)) {
                dispatch({ type: SET_USER_PROFILE, userProfile: userData.profileImage });
            } else {
                const variables = {
                    key: userData.profileImage
                };
                const submitData = { query: getImage, variables: variables };
                axios({
                    method: 'POST',
                    data: submitData,
                    headers: { Authorization: `${token}` }
                })
                    .then(function (response) {
                        if (response.status === 200) {
                            let dummy_data = userData;
                            dispatch({ type: SET_USER_PROFILE, userProfile: response.data.data.getSignedUrlFromKey.signedUrl });
                        }
                    })
                    .catch(function (response) {
                        console.log(response, 'failed loading user data');
                    });
            }
        }
    }, [userData]);

    useEffect(() => {
        const token = localStorage.getItem('diologAuthToken');
        if (companyData.companyLogo) {
            const variables2 = {
                key: companyData.companyLogo
            };
            const submitData2 = { query: getImage, variables: variables2 };
            dispatch({ type: SET_COMPANY_PROFILE_IS_UPDATING, companyProfileLoading: true });
            axios({
                method: 'POST',
                data: submitData2,
                headers: { Authorization: `${token}` }
            })
                .then(function (response) {
                    if (response.status === 200) {
                        let dummy_data = response.data.data.getSignedUrlFromKey.signedUrl;
                        dispatch({ type: SET_COMPANY_PROFILE, companyProfile: dummy_data });
                        dispatch({ type: SET_COMPANY_PROFILE_IS_UPDATING, companyProfileLoading: false });
                    }
                })
                .catch(function (response) {
                    console.log(response, 'failed loading user data');
                    dispatch({ type: SET_COMPANY_PROFILE_IS_UPDATING, companyProfileLoading: false });
                });
        }
        if (companyData.hasOwnProperty('companyLogo')) {
            if (!companyData?.companyLogo) dispatch({ type: SET_COMPANY_PROFILE_IS_UPDATING, companyProfileLoading: false });
        }
    }, [location.pathname]);
    // Commented out: This was causing users to be logged out when navigating to the plan page
    // if (!plan && companyCreator) {
    //     localStorage.clear();
    //     navigate('/');
    // }
    return (
        <>
            <Box sx={{ display: 'flex', minHeight: '100vh' }} className={loading ? 'main-box loading' : 'main-box'}>
                <CssBaseline />
                {/* Dashboard Heading */}
                <AppBar
                    enableColorOnDark
                    position="fixed"
                    color="inherit"
                    elevation={0}
                    sx={{
                        // bgcolor: theme.palette.background.default,
                        backgroundColor: '#23282E',
                        borderBottom: '1px solid rgba(125, 125, 130, 0.25)',
                        transition: leftDrawerOpened ? theme.transitions.create('width') : 'none'
                    }}
                    className="dashboard-header"
                >
                    <Toolbar>
                        <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
                    </Toolbar>
                </AppBar>
                {/* sidebar drawer */}
                <Sidebar drawerType={LAYOUT_CONST.MINI_DRAWER} drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} />
                {/* main content */}

                <Main open={leftDrawerOpened} className="dashborad-main">
                    <PermissionWrapper>
                        {/* breadcrumb */}
                        <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
                        <UploadAlert />
                        <IntegrateDiologQuestions />
                        <Outlet />
                    </PermissionWrapper>
                </Main>

                {/* dashbaord sidebar */}
                {/* {isDashboard && <DashboardSidebar />} */}
            </Box>
            {/* Toast Messages */}

            <Toast />

            {/* Modal Box */}
            <ModalBox />

            {/* <NotValidatedModal handleclose={handleCloseNotValidated} open={openNotValidatedModal} />
            <NotSubscribedModal handleclose={handleCloseNotSubscribed} open={openNotNotSubscribedModal} />
            <NotSubscribedForNonCreatorModal handleclose={handleCloseNotSubscribedNonCreator} open={openNotSubscribedNonCreatorModal} /> */}
        </>
    );
};

export default MainLayout;
